module.exports = __webpack_public_path__ + "img/a784656a917e1bb0e5fcaaa69741f7cd.d7632198.webp";